import axios, { AxiosPromise } from 'axios';
import { IGetSemesterLessonPlans, IGetSemesterLessonPlansParams, IPutSemesterLessonPlansReq } from '../models/semesterLessonPlan2.model';

const uri = '/mgmt/semester-lesson-plan2';

export const getSemesterLessonPlans = (params: IGetSemesterLessonPlansParams): AxiosPromise<IGetSemesterLessonPlans> => {
  return axios.get(uri, { params });
};

export const putSemesterLessonPlans = (req: IPutSemesterLessonPlansReq[]): AxiosPromise => {
  return axios.put(uri, req);
};
